import { ErrorDialogErrorCategory as ReactErrorDialogErrorCategory } from '@office-start/error-dialog-types';
import { Observable } from 'rxjs';

import { FileType } from './file-item.model';

export const enum ErrorDialogErrorCategory {
    MetaOSApp = 'MetaOSApp',
    CreateFile = 'CreateFile',
    StartPage = 'StartPage',
    ContentPage = 'ContentPage',
    VerifyIdentity = 'VerifyIdentity',
    OpenFailed = 'OpenFailed',
    ActionMenu = 'ActionMenu',
    InvalidInput = 'InvalidInput',
    ServerSideError = 'ServerSideError',
    UnsupportedBrowser = 'UnsupportedBrowser',
    Share = 'Share',
    StayingAware = 'StayingAware',
    Upload = 'Upload'
}

export const enum ErrorDialogErrorType {
    None = 'None',
    Generic = 'Generic',
    OneDriveProvisioning = 'OneDriveProvisioning',
    ConditionalAccess = 'ConditionalAccess',
    ConditionalAccessFallback = 'ConditionalAccessFallback',
    NoLicence = 'NoLicence',
    NoLicenceVisio = 'NoLicenceVisio',
    NotFound = 'NotFound',
    Unauthorized = 'Unauthorized',
    Timeout = 'Timeout',
    Offline = 'Offline',
    LoginRequired = 'LoginRequired',
    OneDriveDisabled = 'OneDriveDisabled',
    OpenNewDocFailed = 'OpenNewDocFailed',
    RenameFileFailed = 'RenameFleFailed',
    FluidUnsupportedBrowser = 'FluidUnsupportedBrowser',
    AutoBlockedForm = 'AutoBlockedForm',
    TakenDownForm = 'TakenDownForm',
    WacDocumentBootFailed = 'WacDocumentBootFailed'
}

export interface ErrorDialog {
    category: ErrorDialogErrorCategory;
    error: ErrorDialogErrorType;
    fileType?: FileType;
    inputText?: string;
    errorInfo?: any;
    onActionClicked?: () => void;
    onClose?: () => void; // This will get called if the user closes the dialog, either by pressing the "X" or "Dismiss" buttons.
    dismissDialogObservable?: Observable<any>; // Observable to listen
    skipOnClose?: boolean; // This flag will turn off the onClose listener if it is closed by the dismissDialogObservable
    correlationId?: string;
}

export const getErrorDialogErrorCategory = (reactErrorDialogErrorCategory: ReactErrorDialogErrorCategory): ErrorDialogErrorCategory => {
    switch (reactErrorDialogErrorCategory) {
        case 'MetaOSApp':
            return ErrorDialogErrorCategory.MetaOSApp;
        case 'CreateFile':
            return ErrorDialogErrorCategory.CreateFile;
        case 'StartPage':
            return ErrorDialogErrorCategory.StartPage;
        case 'ContentPage':
            return ErrorDialogErrorCategory.ContentPage;
        case 'VerifyIdentity':
            return ErrorDialogErrorCategory.VerifyIdentity;
        case 'OpenFailed':
            return ErrorDialogErrorCategory.OpenFailed;
        case 'ActionMenu':
            return ErrorDialogErrorCategory.ActionMenu;
        case 'StayingAware':
            return ErrorDialogErrorCategory.StayingAware;
        default:
            return ErrorDialogErrorCategory.InvalidInput;
    }
};